import "@/App.css";
import Observatory from "@/pages/Observatory";

function App() {
  return <Observatory />;
}

export default App;
